export enum ProgramExitTypeNature {
  Pass,
  Fail
}
